<template>
  <div class="mainContent db-page">
    <div class="top-control">
      <div class="tab-content">
        <div class="dashboard-hpo" v-if="renderComponent">
          <muuri-grid id="grid" ref="muurigrid" :options="{dragEnabled: false}">
            <muuri-grid-item width="49%">
              <truck-status-chart @rendered="onChartRendered"></truck-status-chart>
            </muuri-grid-item>
            <muuri-grid-item width="49%">
              <order-status-chart @rendered="onChartRendered"></order-status-chart>
            </muuri-grid-item>
          </muuri-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configs from '@/configs';
import clickoutside from '@/directives/clickoutside';
import TruckStatusChart from '@/components/dashboard/TruckStatusChart';
import OrderStatusChart from '@/components/dashboard/OrderStatusChart';
import { MuuriGridItem } from 'vue-muuri-grid';

export default {
  directives: { clickoutside },
  components:{
    'truck-status-chart': TruckStatusChart,
    'order-status-chart': OrderStatusChart,
    MuuriGridItem,
  },
  data() {
    return {
      showModal: false,
      renderComponent: true,
      popupModalName: '',
      popupModalTitle: '',
      popupModalHeight: 600,
      chartsRendered: 0,
    }
  },
  methods: {
    onChartRendered() {
      this.chartsRendered += 1;
      if (this.chartsRendered === 2) {
        this.$nextTick(() => {
          if (this.$refs.muurigrid && this.$refs.muurigrid.layout) {
            this.$refs.muurigrid.layout();
          }
        });
      }
    }
  },
  mounted() {
    this.$root.$on('zoomChart', (widget) => {
      this.popupModalName = widget.widgetName;
      this.popupModalTitle = widget.widgetTitle;
      this.popupModalHeight = window.innerHeight * 0.6;
    });
  }
}
</script>
<style>
.modal-open{padding-right: 0 !important; }
.modal-backdrop{ z-index: 999998;}
.close:focus{outline:none}
</style>